import './document-tags-list/documentTagsList.scss';
import {useSearchPageType, useSelectedDocContext} from '../../../search-hooks';
import React from 'react';
import {HibuTagList} from './document-tags-list/hibu-tag-list/hibuTagList';
import {deleteTag, upsertTag} from '../../../../services/manual-validation-service';
import {useDispatch} from 'react-redux';
import {HibuTag, TagUpdate} from '../../../search-types';
import {MetadataList} from './document-tags-list/metadata-list/metadataList';
import {AggregationList} from './document-tags-list/aggregation-list/aggregationList';
import {useSpotlightTagTypes} from '../../../../config/config-hooks';

export const TagsRow = (): JSX.Element | null => {
    const searchPageType = useSearchPageType();
    const doc = useSelectedDocContext();
    const dispatch = useDispatch();
    const spotlightTagTypes = useSpotlightTagTypes();
    if (!doc) {
        return null;
    }

    const filteredHibuTagList = {...doc.hibuTags};
    // filter out all tagTypes, that are already displayed in the spotlight tab
    spotlightTagTypes.map(stt => stt.name).forEach(stt => stt in filteredHibuTagList && delete filteredHibuTagList[stt]);

    const removeTag = (tagCategory: string, tag: HibuTag) => {
        const updatedTag: TagUpdate = {
            tagType: tagCategory,
            tagId: tag.id,
            labels: null,
            extra: null,
        };
        const action = deleteTag(searchPageType, doc, updatedTag);
        dispatch(action);
    };

    const changeTag = (
        tagCategory: string,
        tag: HibuTag,
        labels: { [language: string]: string } | null,
        extra: { [key: string]: any } | null
    ) => {
        const updatedTag: TagUpdate = {
            tagType: tagCategory,
            tagId: tag.id,
            labels: labels,
            extra: extra,
        };
        const action = upsertTag(searchPageType, doc, updatedTag);
        dispatch(action);
    };

    const addTag = (
        tagCategory: string,
        tagId: string | null,
        labels: { [language: string]: string } | null,
        extra: { [key: string]: any } | null
    ) => {
        const tag: TagUpdate = {
            tagType: tagCategory,
            tagId: tagId,
            labels: labels,
            extra: extra,
        };
        const action = upsertTag(searchPageType, doc, tag);
        dispatch(action);
    };

    const {heading, ...aggregationsWithoutHeadings} = doc.aggregations ?? {};

    return (
        <>
            <MetadataList/>
            <HibuTagList hibuTags={filteredHibuTagList} removeTag={removeTag} changeTag={changeTag} addTag={addTag}/>
            <AggregationList aggregations={aggregationsWithoutHeadings}/>
        </>
    );
};
